import { select } from '../helpers';

export default () => {
  const openButton = select('.header .open');
  const closeButton = select('.header .close-menu');

  const open = () => select('.header--mobile').classList.add('opened');
  const disableScroll = () => select('body').classList.add('no-scroll');
  const close = () => select('.header--mobile').classList.remove('opened');
  const enableScroll = () => select('body').classList.remove('no-scroll');

  openButton.addEventListener('click', () => {
    open();
    disableScroll();
  });
  closeButton.addEventListener('click', () => {
    close();
    enableScroll();
  });
};
